<div class="user-notes">
    <div *ngIf="isLoading" class="text-center py-4">
        <span class="spinner-border spinner-border-sm"></span>
        <p class="text-muted mt-2">Loading notes...</p>
    </div>

    <div *ngIf="!isLoading">
        <div *ngIf="!notes || notes.length === 0" class="text-center py-2">
            <h5 class="mb-0">No notes added</h5>
            <p class="text-muted mb-4">You still haven't added any notes.</p>
        </div>

        <div *ngIf="notes && notes.length > 0">
            <div class="notes-list">
                <div *ngFor="let note of displayedNotes" 
                     class="note-item mb-3 pt-2 px-3 pb-3 border-start border-warning border-3 rounded-0">
                    <div class="d-flex justify-content-between align-items-center mb-1">
                        <div class="meta text-muted">
                            {{ note.created_at | dateFormat:'MMM dd, y' }}
                        </div>
                        <div class="actions d-flex gap-2">
                            <button class="btn btn-link p-0" title="Edit note" (click)="openEditNoteModal(note)">
                                <img src="assets/common/ic_edit.svg" alt="Edit note">
                            </button>
                            <button class="btn btn-link p-0" title="Delete note" (click)="deleteNote(note)">
                                <img src="assets/common/ic_delete_destructive.svg" alt="Delete note">
                            </button>
                        </div>
                    </div>
                    <div class="note-content">
                        {{ note.content }}
                    </div>
                </div>
            </div>
        </div>
        
        <button class="btn btn-outline-secondary w-100" (click)="openAddNoteModal()">
            Add new note
        </button>
    </div>
</div>

<!-- Note Modal -->
<div *ngIf="showNoteModal" 
     class="blur-modal-backdrop" 
     [class.fade-in]="!isClosingNoteModal" 
     [class.fade-out]="isClosingNoteModal"
     (click)="closeNoteModal()">
</div>

<div *ngIf="showNoteModal" 
     class="mantis-modal" 
     role="dialog" 
     aria-modal="true" 
     [class.modal-in]="!isClosingNoteModal" 
     [class.modal-out]="isClosingNoteModal">
    <div class="modal-dialog" (click)="$event.stopPropagation()">
        <div class="modal-header d-flex justify-content-between align-items-center">
            <h5 class="mb-0 fw-bold">{{ isEditingNote ? 'Edit note' : 'Add new note' }}</h5>
            <button class="btn-close" (click)="closeNoteModal()" title="Close">
                <img src="assets/common/ic_x_s_size.svg" alt="Close" />
            </button>
        </div>
        
        <div class="modal-body">
            <form #noteForm="ngForm" (ngSubmit)="confirmNote(noteForm)">
                <label class="form-label">Note</label>
                <textarea class="form-control" 
                          name="note" 
                          rows="4"
                          required
                          [(ngModel)]="editedNote" 
                          placeholder="Enter your text here" 
                          [class.is-invalid]="showNoteError"></textarea>
                <div class="invalid-feedback d-block" *ngIf="showNoteError">
                    Please enter your note.
                </div>
            </form>
        </div>
        
        <div class="modal-footer d-flex justify-content-end gap-2">
            <button class="btn btn-outline-secondary" (click)="closeNoteModal()">Cancel</button>
            <button class="btn btn-primary" (click)="confirmNote(noteForm)">Confirm</button>
        </div>
    </div>
</div>

